import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Container, Paper, Typography, Button, Alert } from '@mui/material';
import { consumeViewerToken, authorizedViewerUrl } from '../services/viewerAccess';
export default function SecureViewer() {
  const { studyId } = useParams();
  const [token] = useState(consumeViewerToken);
  const [study, setStudy] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    let active = true;
    if (!token) { setError('Sign in or ask the sender for a verified-recipient link.'); return; }
    axios.get((process.env.REACT_APP_API_URL || '') + '/api/secure-viewer/study/' + encodeURIComponent(studyId),
      { headers: { Authorization: 'Bearer ' + token } }).then(response => { if (active) setStudy(response.data.study); })
      .catch(() => { if (active) setError('This study is unavailable for your account.'); });
    return () => { active = false; };
  }, [studyId, token]);
  return <Container maxWidth="sm" sx={{ py: 6 }}><Paper sx={{ p: 4 }}>
    <Typography variant="h5">Image viewer</Typography>
    {error && <Alert severity="error">{error}</Alert>}
    {study && <Button onClick={() => { try { window.location.assign(authorizedViewerUrl(study.studyInstanceUID, token)); } catch (err) { setError(err.message); } }}>Open images</Button>}
  </Paper></Container>;
}
